module.exports = __webpack_public_path__ + "img/turbo_off.36e540bb.png";